import aa from 'search-insights'
import _ from 'lodash'

export const initializeAlgolia = () => {
  aa('init', {
    appId: 'Z0B5QD7VGC',
    apiKey: '54f11690ab8564e1360ab4a376ad6d6c',
  })
}

export const recordClickEvent = (result) => {
  if (_.get(result, 'queryID') && _.get(result, 'algoliaID')) {
    aa('clickedObjectIDsAfterSearch', {
      userToken: _.get(result, 'userToken'),
      index: _.get(result, 'index'),
      eventName: 'Item Clicked',
      queryID: _.get(result, 'queryID'),
      objectIDs: [_.get(result, 'algoliaID')],
      positions: [_.get(result, 'position')]
    })
  }
}
